import { StrictMode } from 'react'
import './i18n'
import { createRoot } from 'react-dom/client'
import './index.css'
import 'remixicon/fonts/remixicon.css'
import App from './App.tsx'

// Depois de um deploy, os arquivos JS mudam de nome (hash de conteúdo). Quem
// já estava com o site aberto na aba e navega pra uma rota lazy-loaded (troca
// de tela sem recarregar a página) tenta buscar um chunk que não existe mais
// no servidor -- isso derruba o import e deixa a tela em branco. Recarrega a
// página uma vez pra pegar o index.html/chunks atuais (evita loop se o
// problema persistir, ex: falha de rede de verdade).
window.addEventListener('vite:preloadError', () => {
  if (sessionStorage.getItem('vite-reload-on-preload-error')) return;
  sessionStorage.setItem('vite-reload-on-preload-error', '1');
  window.location.reload();
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
